<template>
    <router-view></router-view>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AdminSearchContainer",
  data: () => ({}),
  methods: {},
  mounted () {}
};
</script>

<style scoped>
</style>
